import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface StreamingViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class StreamingViewPage extends Component<StreamingViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.streaming(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}